// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"04423ceb","732":"6987bb90","977":"960e1102"}[chunkId] + ".chunk.js";
};